<template>
    <section>
       <div class="content-wrapper">
           <div class="row">
               <h1 class="text-center">Mes cartes cadeaux offertes</h1>
               <div class="col-md-12">
                   <div v-if="isload" class="jumping-dots-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                </div>
                   <b-table 
                    :items="items" 
                    id="table-list" 
                    responsive :per-page="perPage" 
                    :current-page="currentPage" 
                    :fields="fields" 
                    :sort-by.sync="sortBy" 
                    :sort-desc.sync="sortDesc"
                    :filter="search"
                    >
                  <template #cell(client)="row">
                    <span class="pointer" v-b-modal="row.item.ulid">{{row.item.receiver.firstname}}
                        <!-- pour pouvoir récupérer la valeur Row -->
                        <b-modal :id="row.item.ulid" :title="'Carte cadeau offert à '+ row.item.receiver.firstname" hide-footer>
                            <h3>Offert à</h3>
                            <p><span class="text-muted">Nom du bénéficiaire:</span> {{row.item.receiver.firstname}}  {{row.item.receiver.lastname}}</p>
                            <p><span class="text-muted">Email :</span>  {{row.item.receiver.email}}</p>
                            <p><span class="text-muted">Contact :</span>  {{row.item.receiver.tel}}</p>
                            <h3>le</h3>
                            <p>{{row.item.datepublished}}</p>
                            <h3>Message</h3>
                            <p>{{row.item.message}}</p>
                            <p class="text-right text-muted">durée: 6 mois</p>
                        </b-modal>
                    </span>
                  </template>
                  <template #cell(type)>
                    <span>
                      <span class="badge badge-outline-default badge-pill"><i class="mdi mdi-calendar mr-2"></i>Carte cadeau</span>
                    </span>
                  </template>

                  <template #cell(date)="row">
                    <span>{{formatDate2(row.item.datepublished)}}</span>
                  </template>

                  <template #cell(status)>
                    <span class="badge badge-success">Succès</span>
                  </template>

                  <!-- <template #cell(#)="row">
                    <a @click="removeOrder(row)" class="btn btn-danger btn-sm"> <i class="fa fa-trash" ></i> </a>
                  </template> -->

                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="table-list"
                  align="right">
                </b-pagination>
               </div>
           </div>
       </div>
    </section>
</template>
<script>
import axios from 'axios'
import { dateMixin } from './mixins/date'
export default {
    name:"myvoucher",
    mixins:[dateMixin],
    data(){
        return{
            perPage: 10,
            isload:true,
            sortBy: 'name',
            currentPage: 1,
            sortDesc: false,
            sortByFormatted: true,
            filterByFormatted: true,
            sortable: true,
            search:'',
            fields: [
            { key: 'client', label:'Bénéficiaire', sortable: true },
            { key: 'type', sortable: true },
            { key: 'date', sortable: true },
            { key: 'status', sortable: true },
            // { key: '#' }
            ],
            items: [
            ]
        }
    },
    computed: {
        rows() {
        return this.items.length
      }
    },
    methods: {
        details(record){
            this.voucherDetails(record.ulid)
        },
        getMyVouchers () {
            this.isload = true
            axios.get('myvoucher', {
             headers: {
                 'X-AUTH-TOKEN': localStorage.getItem('token')
             }   
            })
            .then(async resGetMyOrders => {
                // let res = resGetMyOrders.data.result
                // let respurchases = await res.filter(i => i.purchases.length>0 )
                // this.items = respurchases.filter(i => i.purchases[0].service)
                this.items = resGetMyOrders.data.result
                console.log("liste voucher", this.items);

                
            this.isload = false

            })
            .catch(errGetMyOrders => console.log({errGetMyOrders}))
        },
        voucherDetails(ulid) {
            this.$bvModal.show(ulid)
        },
        removeOrder(order){
            this.$swal({
                title: 'Désirez-vous annuler votre réservation?',
                showCancelButton: true,
                confirmButtonColor: '#0b0b0b',
                cancelButtonColor: '#fff',
                confirmButtonText: 'Valider',
                cancelButtonText: 'Annuler'
            })
            .then((result) => {
                if (result.value) {
                this.isload =true
                axios.delete('myorders/'+order.item.ulid)
                    .then(()=>{
                    this.getMyOrders()
                    })
                    .catch()
                }else{
                    this.isload=false
                }
            })
        }
    },
    mounted () {
        this.getMyVouchers()
    }
}
</script>